import React from "react";
import * as styles from "./styledLink.module.scss";

interface Props {
  link: string;
  text: string;
  className?: string;
  onClick?: any;
}

export const StyledLink: React.FC<Props> = ({
  link,
  text,
  className,
  onClick,
}) => {
  return (
    <a
      className={styles.link}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <button className={`${className} ${styles.text}`}>{text}</button>
    </a>
  );
};
